import {
  Component,
  AfterViewChecked,
  ChangeDetectorRef,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseCRUDService } from '../shared/services/BaseCRUDService';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';
import { EditorModule } from '@openng/optimus-ui/editor';
import { TableModule } from '@openng/optimus-ui/table';
import { ButtonModule } from '@openng/optimus-ui/button';

import { ServiceRequestBase } from '../_interfaces/ServiceRequestBase';

@Component({
  selector: 'app-list-view',
  imports: [EditorModule, ButtonModule, TableModule, FormsModule, CommonModule, RouterLink],
  templateUrl: './list-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list-view.css',
})
export class ListView implements AfterViewChecked {
  @Input({ required: true }) service?: BaseCRUDService;
  @Input() disableEdit: boolean = false;
  @Input() displayedColumns: string[] = ['id'];
  @Input() url?: string;
  @Input() newUrl?: string;
  data: ServiceRequestBase[] = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
  ) {}

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    if (!this.disableEdit) this.displayedColumns.push('actions');
    this.service?.list().subscribe((at) => {
      this.data = at as ServiceRequestBase[];
      this.changeDetectorRef.detectChanges();
    });
  }

  addRow(): void {
    if (this.newUrl) {
      this.router.navigate([this.newUrl]);
    } else {
      // Add new row with empty values and edit mode enabled
      this.data.push({
        id: -1,
        isEditing: true, // New rows start in edit mode
      });
    }
  }

  enableEditMode(row: ServiceRequestBase): void {
    // Store original data for cancel action
    row.originalData = { ...row };
    row.isEditing = true;
  }

  updateRow(row: ServiceRequestBase): void {
    // Exit edit mode
    row.isEditing = false;
    delete row.originalData; // Clean up temporary data
    if (row.id == -1)
      this.service?.create(row).subscribe((am) => {
        row.id = am.id;
        this.changeDetectorRef.detectChanges();
      });
    else this.service?.update(row.id, row).subscribe(() => {});
  }

  deleteEdit(row: ServiceRequestBase) {
    if (window.confirm($localize`Are sure you want to delete this item ${row.id}?`)) {
      this.data = this.data.filter((at) => {
        return at.id != row.id;
      });
      this.service?.delete(row.id).subscribe(() => {});
      this.changeDetectorRef.detectChanges();
    }
  }

  cancelEdit(row: ServiceRequestBase): void {
    // Revert to original data
    Object.assign(row, row.originalData);
    row.isEditing = false;
    delete row.originalData; // Clean up
  }
}
